<app-audio-input-control [formControl]="formControl"
                         [clipControl]="clipControl"></app-audio-input-control>
